import type { SearchResult } from '@/scopes/search/search/infrastructure/api/types'
import { IconGlyph } from '@sunwebgroup/ui-components/uds'
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchProductClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSearchStore } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { ProductCard, ProductCardSplitDetails } from './ProductCard'

export interface AccommodationService {
  icon?: IconGlyph
  text: string
  key: string
}

export interface ResultProps extends SearchResult {
  showAirportDropdown: boolean
}

export function Result({ showAirportDropdown, ...result }: ResultProps) {
  const { filterSelection } = useSearchStore()
  const { sendEvent } = useAnalytics()
  const { productCardSplitDetails } = useOptimizelyFlagContext()

  const onClickHandler = () => {
    sendEvent(createSearchProductClickEvent(result))
  }
  const ProductCardComponent = productCardSplitDetails ? ProductCardSplitDetails : ProductCard

  return (
    <ProductCardComponent
      result={result}
      participants={filterSelection?.Participants}
      onClick={onClickHandler}
      showAirportDropdown={showAirportDropdown}
    />
  )
}
